import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Pages
import Layout from "./pages/Layout";
import Overview from "./pages/Overview";
import Contact from "./pages/Component/Contact";
import Resume from "./pages/Component/Resume";
import CertificatesWrapper from "./pages/CertificatesWrapper";
import AboutWrapper from "./pages/AboutWrapper";
import PortfolioWrapper from "./pages/PortfolioWarapper";
import type { PortfolioSiteData } from "./types/resume";
import Artikel from "./pages/Component/Artikel";
import resumeDataJson from "./data/resumeData.json";

const App = () => {
  const [resumeData] = useState<Partial<PortfolioSiteData>>(
    resumeDataJson as Partial<PortfolioSiteData>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout data={resumeData} />}>
          <Route index element={<Overview />} />
          <Route path="about" element={<AboutWrapper />} />
          <Route path="resume" element={<Resume />} />
          <Route path="portfolio" element={<PortfolioWrapper />} />
          <Route path="certificates" element={<CertificatesWrapper />} />
          <Route path="artikel" element={<Artikel />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
